import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedUserRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) return null;

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/account-login"
                state={{ from: location }}
                replace
            />
        );
    }

    return children;
};

export default ProtectedUserRoute;
